import { useUserContext } from "@/components/user-context";

import { LoggedInJira } from "./logged-in/logged-in";
import { LoggedOutJira } from "./logged-out";

export const JiraSignup = () => {
    const {
        user: { isUserLoggedIn }
    } = useUserContext();

    if (isUserLoggedIn) {
        return <LoggedInJira />;
    }

    return <LoggedOutJira />;
};
